"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StandardView_1 = require("./StandardView");
exports.default = StandardView_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/StandardView/index.js
// module id = 1722
// module chunks = 8